export const POSTS_PER_PAGE = 12;
export const CLOUDFLARE_BEACON = "51861b2c85a54c1d92388a99a5115079"